import React, { useEffect } from "react";
import { LoadingState } from "../../components/HOC/withPreloading/types";
import { usePreloader, withPreloading } from "../../components/HOC/withPreloading/withPreloading";
import { PermissionFallbackComponent } from "../../components/HOC/withPermissionFallback/permissionFallbackComponent";
import { useStore } from "../../models";
import { ReportsScope } from "../../models/reports/ReportsScope";
import { DashboardView } from "../dashboard/views/DashboardView";
import styles from "../settings/settings.css";
import { ReportsContainer } from "./reportsContainer";
import { ReportsNavigation } from "./reportsNavigation";

export interface Props {
  view: DashboardView;
  scope: ReportsScope;
}

const ReportsComponent = ({ view, scope }: Props) => {
  const { currentUserStore, reportsStore, uiStore } = useStore();
  const { setLoadingState } = usePreloader();

  useEffect(() => {
    const loadProfileData = async () => {
      await currentUserStore.loadProfileData();
      reportsStore.refreshRaports();
      setLoadingState(LoadingState.Loaded);
    };

    loadProfileData();
  }, []);

  if (!uiStore.canDisplayReports) {
    return <PermissionFallbackComponent />;
  }

  return currentUserStore.orgConfig?.reportsEnabled ? (
    <div className={styles["settings-container"]}>
      <ReportsNavigation view={view} scope={scope} />
      <ReportsContainer view={view} scope={scope} />
    </div>
  ) : (
    <></>
  );
};

export const Reports = withPreloading(ReportsComponent);
